module.exports = __webpack_public_path__ + "images/pro/ic-storage-gift@2x-d07f380906cd709f2b60e08821dce792.png";